import debounce from "lodash/debounce";
import { managedFetch } from "./utils/FetchManager";
import { downloadBlob } from "./utils/file";

export async function getClosestNamedLocation(ignition) {
  const centroid = turf.centroid(ignition);
  const revGeo = `https://api.mapbox.com/geocoding/v5/mapbox.places/${centroid.geometry.coordinates.join(",")}.json?access_token=${mapboxgl.accessToken}&types=place,district`;
  const res = await managedFetch(revGeo);
  const data = await res.json();
  return data.features[0].place_name;
}

// Formats current date and time as 'yyyy-mm-dd-hh-mm-ss'
export function formatDate(date) {
  return date
    .toISOString()
    .slice(0, 19)
    .replace("T", "_")
    .replace(/:/g, "")
    .replace(/-/g, "");
}

export function downloadRun(currRun) {
  if (!currRun) {
    alert("No Data to Download Yet.");
    return;
  }
  const blob = new Blob([JSON.stringify(currRun, null, 2)], {
    type: "text/plain",
  });
  const formattedDate = formatDate(new Date());
  const name = currRun.name ? currRun.name.replace(/[^\w]/g, "") : "";
  downloadBlob(blob, `xyloplan_${name}_${formattedDate}.json`);
}

// iOS Safari ignores presence/absence of address bar when calculating CSS viewport units, so `100vh` height elements are actually cut off sometimes. This creates a CSS variable that accurately reflects viewport height, e.g. `height: calc(var(--vh, 1vh) * 100)`
function updateVH() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
}
updateVH();
window.addEventListener("resize", debounce(updateVH, 250));

export function degreesToCardinal(degrees) {
  const directions = [
    "North",
    "Northeast",
    "East",
    "Southeast",
    "South",
    "Southwest",
    "West",
    "Northwest",
  ];
  const index = Math.round(degrees / 45) % 8;
  return directions[index];
}

export function degreesToCardinalShort(degrees) {
  const directions = ["N", "NE", "E", "SE", "S", "SW", "W", "NW"];
  const index = Math.round(degrees / 45) % 8;
  return directions[index];
}
